import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { useState, useEffect } from "react";

const FormCrearComboProductos = ({
    empresa,
    listaEmpresas,
    loading,
    setLoading,
    baseUrl,
    nombreEmpresa,
    setProductos,
    productoCombinado,
    setProductoCombinado,
    setProductosFiltrados,
    displayDialogCombinatoria,
    setDisplayDialogCombinatoria,
    productosFiltrados,
    fetchDataProductos,
    toast,
}) => {
    const [tipoProductoOptions, setTipoProductoOptions] = useState([]);
    const idUsuario = sessionStorage.getItem("usuario_id");
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);

    useEffect(() => {
        const cargarTiposProducto = async () => {
            const tipos = await fetchTiposProductoTodasEmpresas();
            setTipoProductoOptions(tipos);
        };
        cargarTiposProducto();
    }, []);

    const fetchData = async () => {
        if (!empresa) return;
        
        try {
            setLoading(true);
            const response = await fetch(`${baseUrl}getProductosByEmpresa?empresa=${nombreEmpresa}`);
            const data = await response.json();
            setProductos(data.productos);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching productos:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchTiposProductoTodasEmpresas = async () => {
        try {
            const response = await fetch(`${baseUrl}getTiposProductoByEmpresa?empresa=TODAS`);
            const data = await response.json();
            return response.ok ? data.tiposProductos : [];
        } catch (error) {
            console.error('Error al obtener tipos de productos:', error);
            return [];
        }
    };

    const filtrarProductosPorTipoTodasEmpresas = async (tipoProducto) => {
        if (!tipoProducto) {
            setProductosFiltrados([]);
            return;
        }

        try {
            setLoading2(true);
            const response = await fetch(
                `${baseUrl}getProductosByTipo?idTipo=${tipoProducto.id}`
            );
            const data = await response.json();
            
            if (response.ok) {
                const productosActivos = data.productos.filter(producto => producto.activo);
                setProductosFiltrados(productosActivos);
            } else {
                setProductosFiltrados([]);
            }
        } catch (error) {
            console.error('Error al filtrar productos:', error);
            setProductosFiltrados([]);
        } finally {
            setLoading2(false);
        }
    };

    const verificarAsignacionProducto = async (productos) => {
        try {
            for (const producto of productos) {
                const response = await fetch(
                    `${baseUrl}verificarProductoAsignado?idProducto=${producto.id}`,
                    { method: 'GET', headers: { 'Content-Type': 'application/json' } }
                );
                
                if (!response.ok) {
                    throw new Error('Error al verificar disponibilidad del producto');
                }
                
                const result = await response.json();
                
                if (!result.disponible) {
                    return { asignado: true, producto: producto, detalles: result };
                }
            }
            
            return { asignado: false };
        } catch (error) {
            console.error('Error al verificar asignación de productos:', error);
            return { asignado: true, error: true };
        }
    };

    const validarProductoCombinado = async () => {
        const { productos, descripcionCombinada } = productoCombinado;
        
        if (!productos || productos.length < 2) {
            return "Debe seleccionar al menos 2 productos para combinar.";
        }
        
        if (!descripcionCombinada?.trim()) {
            return "La descripción del producto combinado es obligatoria.";
        }

        // Usar en la validación
        // const nombreEsUnico = await validarNombreUnico(descripcionCombinada);
        // if (!nombreEsUnico) {
        //     return "El nombre de la combinación ya existe, reingrese.";
        // }
        
        // Verificar asignaciones
        const resultadoAsignacion = await verificarAsignacionProducto(productos);
        if (resultadoAsignacion.asignado) {
            if (resultadoAsignacion.error) {
                return "Error al verificar disponibilidad de productos.";
            }
            
            const { producto, detalles } = resultadoAsignacion;
            let mensaje = `El producto "${producto.descripcion}" se encuentra asignado.`;
            
            if (detalles.id_contrato) {
                mensaje += ` Contrato: ${detalles.id_contrato}`;
            }
            
            if (detalles.fecha_inicio && detalles.fecha_termino) {
                mensaje += ` (${detalles.fecha_inicio} - ${detalles.fecha_termino})`;
            }
            
            return mensaje;
        }
        
        return null;
    };

    const validarProductoCombinado2 = async () => {
        const { productos, descripcionCombinada, nuevoTipoProducto, tarifa } = productoCombinado;
        
        if (!productos || productos.length < 2) {
            return "Debe seleccionar al menos 2 productos para combinar.";
        }
        
        if (!descripcionCombinada?.trim()) {
            return "La descripción del producto combinado es obligatoria.";
        }

        if (!nuevoTipoProducto) {
            return "Debe ingresar el tipo de producto.";
        }
        
        const tipoEsUnico = await validarTipoUnico(nuevoTipoProducto);
        if (!tipoEsUnico) {
            return "El tipo de producto ya existe, reingrese.";
        }
        
        if (!tarifa || tarifa <= 0) {
            return "Debe ingresar la tarifa del producto.";
        }
        
        // Verificar asignaciones
        const resultadoAsignacion = await verificarAsignacionProducto(productos);
        if (resultadoAsignacion.asignado) {
            if (resultadoAsignacion.error) {
                return "Error al verificar disponibilidad de productos.";
            }
            
            const { producto, detalles } = resultadoAsignacion;
            let mensaje = `El producto "${producto.descripcion}" se encuentra asignado.`;
            
            if (detalles.id_contrato) {
                mensaje += ` Contrato: ${detalles.id_contrato}`;
            }
            
            if (detalles.fecha_inicio && detalles.fecha_termino) {
                mensaje += ` (${detalles.fecha_inicio} - ${detalles.fecha_termino})`;
            }
            
            return mensaje;
        }
        
        return null;
    };

    const validarProductoCombinado3 = async () => {
        const { productos, descripcionCombinada, nuevoTipoProducto, tarifa, empresaArrendadora } = productoCombinado;
        
        if (!productos || productos.length < 2) {
            return "Debe seleccionar al menos 2 productos para combinar.";
        }
        
        if (!descripcionCombinada?.trim()) {
            return "La descripción del producto combinado es obligatoria.";
        }

        if (!nuevoTipoProducto) {
            return "Debe ingresar el tipo de producto.";
        }

        const tipoEsUnico = await validarTipoUnico(nuevoTipoProducto);
        if (!tipoEsUnico) {
            return "El tipo de producto ya existe, reingrese.";
        }

        if (!tarifa || tarifa <= 0) {
            return "Debe ingresar la tarifa del producto.";
        }

        if (!empresaArrendadora) {
            return "Debe seleccionar una empresa arrendadora.";
        }
        
        // Verificar asignaciones
        const resultadoAsignacion = await verificarAsignacionProducto(productos);
        if (resultadoAsignacion.asignado) {
            if (resultadoAsignacion.error) {
                return "Error al verificar disponibilidad de productos.";
            }
            
            const { producto, detalles } = resultadoAsignacion;
            let mensaje = `El producto "${producto.descripcion}" se encuentra asignado.`;
            
            if (detalles.id_contrato) {
                mensaje += ` Contrato: ${detalles.id_contrato}`;
            }
            
            if (detalles.fecha_inicio && detalles.fecha_termino) {
                mensaje += ` (${detalles.fecha_inicio} - ${detalles.fecha_termino})`;
            }
            
            return mensaje;
        }
        
        return null;
    };

    // ===== FUNCIONES DE MANEJO DE ESTADO =====
    const handleTipoProductoCombinatoria = (tipoProducto) => {
        setProductoCombinado({
            ...productoCombinado,
            tipoProducto,
            descripcionCombinada: "",
            metraje: "",
            tarifa: ""
        });
        filtrarProductosPorTipoTodasEmpresas(tipoProducto);
    };

    const handleAgregarProducto = (producto) => {
        const productosActuales = productoCombinado.productos || [];
        
        if (productosActuales.some(p => p.id === producto.id)) {
            alert("Este producto ya está en la combinación.");
            return;
        }
        
        const nuevosProductos = [...productosActuales, producto];
        actualizarProductoCombinado('productos', nuevosProductos);
    };

    const handleRemoverProducto = (productoId) => {
        const nuevosProductos = productoCombinado.productos.filter(p => p.id !== productoId);
        actualizarProductoCombinado('productos', nuevosProductos);
    };

    const actualizarProductoCombinado = (campo, valor) => {
        const nuevoEstado = { ...productoCombinado, [campo]: valor };
        
        if (campo === 'productos') {
            const productos = valor;
            
            if (productos && productos.length > 0) {
                nuevoEstado.descripcionCombinada = productos.map(p => p.descripcion).join(' + ');
                nuevoEstado.metraje = productos.reduce((total, p) => total + parseFloat(p.metraje || 0), 0).toString();
                //nuevoEstado.tarifa = productos.reduce((total, p) => total + parseFloat(p.tarifa || 0), 0).toString();
            } else {
                nuevoEstado.descripcionCombinada = "";
                nuevoEstado.metraje = "";
                //nuevoEstado.tarifa = "";
            }
        }
        
        setProductoCombinado(nuevoEstado);
    };

    const createTipoProductoAPI = async (
        empresa,
        descripcion,
        unidad,
        tarifa
    ) => {
        try {
            const queryParams = new URLSearchParams({
                empresa,
                descripcion,
                unidad,
                idUsuario,
                tarifa,
            });
            const response = await fetch(
            `${baseUrl}createTipoProducto?${queryParams.toString()}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json;charset=UTF-8" },
                }
            );
            const data2 = await response.json();

            if (!response.ok) {
                throw new Error(data2.mensaje || "Error creating TipoProducto"); 
            }

            //alert("Combo Producto creado exitosamente.");
            return data2;
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error creating TipoProducto", life: 3000 });
            throw error;
        }
    };

    const createComboProductAPI = async ({ empresa, descripcion, idTipo, productos }) => {
        setLoading3(true);
        try {
            const queryParams = new URLSearchParams({
                empresa,
                descripcion,
                idTipo,
                productos: JSON.stringify(productos),
                idUsuario
            });
            console.log(queryParams.toString());
            const response = await fetch(
                `${baseUrl}createUnionProducto?${queryParams.toString()}`,
                { method: "POST", headers: { "Content-Type": "application/json;charset=UTF-8" } }
            );
            
            const data = await response.json();
            
            if (!response.ok) {
                throw new Error(data.mensaje || "Error al crear producto");
            }
            
            //alert("Combo Producto creado exitosamente.");
            await fetchDataProductos();
            return data;
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al crear Producto combinado", life: 3000 });
            throw error;
        } finally {
            setLoading3(false);
        }
    };

    const validarTipoUnico = async (nuevoTipoProducto) => {
        try {
            const response = await fetch(`${baseUrl}verificarTipoCombo?descripcion=${encodeURIComponent(nuevoTipoProducto)}`, {
                method: 'GET',
            });
            const result = await response.json();
            return !result.existe; // true si no existe, false si ya existe
        } catch (error) {
            console.error('Error al verificar nombre:', error);
            return false;
        }
    };

    const handleCreateProductoCombinado = async () => {
        try{
            setLoading(true);
            // Calcular el escenario
            const escenario = determinarEscenarioCombinacion(productoCombinado.productos);
            //console.log(escenario);
            //console.log(productoCombinado);
            switch (escenario) {
                case 'MISMA_EMPRESA_MISMO_TIPO':
                    //console.log("MISMA_EMPRESA_MISMO_TIPO");
                    const error = await validarProductoCombinado();
                    if (error) {
                        alert(error);
                        setLoading(false);
                        return;
                    }
                    try {
                        const newCombo = {
                            empresa: productoCombinado.tipoProducto.nombre_empresa,
                            descripcion: productoCombinado.descripcionCombinada,
                            idTipo: productoCombinado.tipoProducto.id,
                            productos: productoCombinado.productos.map(p => p.id)
                        };
                        
                        await createComboProductAPI(newCombo);

                        // Resetear estado
                        setProductoCombinado({
                            tipoProducto: "",
                            productos: [],
                            descripcionCombinada: "",
                            metraje: "",
                            tarifa: ""
                        });
                        toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Combo Producto creado exitosamente.', life: 3000 });
                        setProductosFiltrados([]);
                        fetchData();
                    } catch (error) {
                        console.error("Error al crear producto combinado:", error);
                        toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al crear Producto combinado", life: 3000 });
                    }
                    break

                case 'MISMA_EMPRESA_DIFERENTE_TIPO':
                    //console.log("MISMA_EMPRESA_DIFERENTE_TIPO");
                    // validar campos
                    const error2 = await validarProductoCombinado2();
                    if (error2) {
                        alert(error2);
                        setLoading(false);
                        return;
                    }
                    //crear el nuevo tipo producto en la misma empresa
                    let tipoProductoId;
                    try{
                        const tipoProductoCreado = await createTipoProductoAPI(
                            productoCombinado.tipoProducto.nombre_empresa,
                            productoCombinado.nuevoTipoProducto,
                            "m**2",
                            productoCombinado.tarifa
                        );
                        //rescata el id de nuevo tipo
                        tipoProductoId = tipoProductoCreado.tipoProductoId; // Guardar en constante
                    }catch(error){
                        console.error("Error al crear tipo producto", error);
                    }
                    
                    //crear la combinacion
                    try {
                        const newCombo = {
                            empresa: productoCombinado.tipoProducto.nombre_empresa,
                            descripcion: productoCombinado.descripcionCombinada,
                            idTipo: tipoProductoId,
                            productos: productoCombinado.productos.map(p => p.id)
                        };
                        
                        await createComboProductAPI(newCombo);

                        // Resetear estado
                        setProductoCombinado({
                            tipoProducto: "",
                            productos: [],
                            descripcionCombinada: "",
                            metraje: "",
                            tarifa: ""
                        });
                        toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Combo Producto creado exitosamente.', life: 3000 });
                        setProductosFiltrados([]);
                        fetchData();
                    } catch (error) {
                        console.error("Error al crear producto combinado:", error);
                        toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al crear Producto combinado", life: 3000 });
                    }

                    break
                
                case 'DIFERENTES_EMPRESAS':
                    //console.log("DIFERENTES_EMPRESAS");
                    // validar campos
                    const error3 = await validarProductoCombinado3();
                    if (error3) {
                        alert(error3);
                        setLoading(false);
                        return;
                    }

                    //crear el nuevo tipo producto en la empresa definida
                    let tipoProductoId2;
                    try{
                        const tipoProductoCreado2 = await createTipoProductoAPI(
                            productoCombinado.empresaArrendadora,
                            productoCombinado.nuevoTipoProducto,
                            "m**2",
                            productoCombinado.tarifa
                        );
                        //rescata el id de nuevo tipo
                        tipoProductoId2 = tipoProductoCreado2.tipoProductoId; // Guardar en constante
                    }catch(error){
                        console.error("Error al crear tipo producto", error);
                    }

                    //crear la combinacion
                    try {
                        const newCombo = {
                            empresa: productoCombinado.empresaArrendadora,
                            descripcion: productoCombinado.descripcionCombinada,
                            idTipo: tipoProductoId2,
                            productos: productoCombinado.productos.map(p => p.id)
                        };

                        await createComboProductAPI(newCombo);

                        // Resetear estado
                        setProductoCombinado({
                            tipoProducto: "",
                            productos: [],
                            descripcionCombinada: "",
                            metraje: "",
                            tarifa: ""
                        });
                        toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Combo Producto creado exitosamente.', life: 3000 });
                        setProductosFiltrados([]);
                        fetchData();
                    } catch (error) {
                        console.error("Error al crear producto combinado:", error);
                        toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || "Error al crear Producto combinado", life: 3000 });
                    }
                    break
                    
                default:
                    console.log("default");
                    break
            }
        }catch(error){
            console.error("Error al crear producto combinado:", error);
        }finally{
            setDisplayDialogCombinatoria(false);
        }
    };

    const footerCombinarProd = () => {
        return (
            <div className="p-d-flex p-jc-end p-mt-3">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={() => {
                        setDisplayDialogCombinatoria(false);
                        setProductoCombinado({
                            tipoProducto: "",
                            productos: [],
                            descripcionCombinada: "",
                            metraje: "",
                            tarifa: ""
                        });
                        setProductosFiltrados([]);
                    }}
                    className="p-button p-mr-2 p-button-outlined p-button-rounded p-button-md"
                    raised
                />
                <Button
                    label="Guardar"
                    icon={loading3 ? "pi pi-spin pi-spinner" : "pi pi-save"}
                    onClick={handleCreateProductoCombinado}
                    className="p-button-success p-button-rounded p-button-md"
                    raised
                    autoFocus
                    disabled={loading || !productoCombinado.productos || productoCombinado.productos.length < 2 || loading2 || loading3}
                />
            </div>
        );
    };

    const determinarEscenarioCombinacion = (productos) => {
        if (!productos || productos.length === 0) {
            return null;
        }
        
        // Get unique companies and product types
        const empresas = [...new Set(productos.map(p => p.nombreEmpresa))];
        const tipos = [...new Set(productos.map(p => p.tipoProducto))];
        
        // Different companies scenario
        if (empresas.length > 1) {
            return 'DIFERENTES_EMPRESAS';
        }
        
        // Same company but different product types
        if (tipos.length > 1) {
            return 'MISMA_EMPRESA_DIFERENTE_TIPO';
        }
        
        // Same company and same product type
        return 'MISMA_EMPRESA_MISMO_TIPO';
    };

    return (
        <>
            <Dialog
                header="Unir Productos"
                visible={displayDialogCombinatoria}
                className="p-fluid product-dialog"
                onHide={() => {
                    setDisplayDialogCombinatoria(false);
                    setProductoCombinado({
                        tipoProducto: "",
                        productos: [],
                        descripcionCombinada: "",
                        metraje: "",
                        tarifa: "",
                        empresaArrendadora: "",
                        nuevoTipoProducto: ""
                    });
                    setProductosFiltrados([]);
                }}
                footer={footerCombinarProd()}
            >
                <div className="p-grid p-formgrid p-fluid">
                    {/* SECCIÓN 1: SELECCIÓN DE TIPO Y PRODUCTOS */}
                    <div className="col-12 mb-2">
                        <div className="p-card p-3">
                            <h6 className="mb-3">Paso 1: Seleccionar Productos</h6>
                            
                            {/* tipo de producto */}
                            <span className="p-float-label mt-2 mb-3">
                                <Dropdown
                                    id="tipoProductoCombinatoria"
                                    value={productoCombinado.tipoProducto}
                                    options={tipoProductoOptions}
                                    onChange={(e) => handleTipoProductoCombinatoria(e.value)}
                                    optionLabel={(option) => `${option.descripcion} (${option.nombre_empresa})`}
                                    placeholder="Seleccione un tipo de producto"
                                    required
                                />
                                <label htmlFor="tipoProductoCombinatoria"><i className="pi pi-tags"></i> Tipos (Todas las Empresas)</label>
                            </span>
                            
                            {productoCombinado.tipoProducto && (
                                <div>
                                    {/* Selector de productos disponibles */}
                                    <span className="p-float-label mt-2 mb-3">
                                        <Dropdown
                                            id="selectorProductos"
                                            value={null}
                                            options={productosFiltrados.filter(p => 
                                                !productoCombinado.productos.some(selected => selected.id === p.id)
                                            )}
                                            onChange={(e) => handleAgregarProducto(e.value)}
                                            optionLabel="descripcion"
                                            itemTemplate={(option) => (
                                                <div className="flex align-items-center">
                                                    <span>{option.descripcion}</span>
                                                    <span className="ml-2" style={{fontSize: '0.8em', color: '#666'}}>
                                                        ({option.asignado?.asignado ? 'asignado' : 'disponible'})
                                                    </span>
                                                </div>
                                            )}
                                            placeholder={loading2 ? "Cargando productos..." : "Seleccione un producto para agregar"}
                                            disabled={productosFiltrados.length === 0 || loading2}
                                        />
                                        <label htmlFor="selectorProductos">
                                            {loading2 ? (
                                                <>
                                                    <i className="pi pi-spin pi-spinner mr-1"></i>Cargando productos...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="pi pi-plus mr-1"></i>Agregar Producto (Total {productosFiltrados.length})
                                                </>
                                            )}
                                        </label>
                                    </span>

                                        {/* Lista de productos seleccionados */}
                                        {productoCombinado.productos && productoCombinado.productos.length > 0 && (
                                            <div className="mt-4">
                                                <h6 className="mb-2">Listado de Productos (Seleccionados {productoCombinado.productos.length})</h6>
                                                {productoCombinado.productos.map((producto, index) => (
                                                    <div key={producto.id} className="p-card p-2 mb-2" style={{ backgroundColor: "#f8f9fa", border: "1px solid #dee2e6" }}>
                                                        <div className="flex justify-content-between align-items-center">
                                                            <div className="flex align-items-center">
                                                                <i className="pi pi-circle mr-2" style={{ color: `hsl(${index * 60}, 70%, 50%)` }}></i>
                                                                <div>
                                                                    <strong>{producto.descripcion}</strong>
                                                                    <div className="text-sm text-600">Empresa: {producto.nombreEmpresa}</div>
                                                                    <div className="text-sm text-600">Tipo: {producto.tipoProducto}</div>
                                                                    <div className="text-sm text-600">Metraje: {producto.metraje} m²</div>
                                                                    <div className="text-sm text-600">Tarifa: {producto.tarifa} UF</div>
                                                                </div>
                                                            </div>
                                                            <Button
                                                                icon="pi pi-times"
                                                                className="p-button-rounded p-button-text p-button-danger"
                                                                onClick={() => handleRemoverProducto(producto.id)}
                                                                tooltip="Remover producto"
                                                                disabled={loading}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        
                        {productoCombinado.productos && productoCombinado.productos.length >= 2 && (
                            <>
                                {/* SECCIÓN 2: PRODUCTO FINAL */}
                                <div className="col-12">
                                    <div className="p-card p-3" style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "8px" }}>
                                        <h6 className="mb-2">Paso 2: Definir Unión</h6>
                                        
                                        {/* Mostrar el escenario detectado */}
                                        {(() => {
                                            const escenario = determinarEscenarioCombinacion(productoCombinado.productos);
                                            let mensaje = "";
                                            let color = "";
                                            
                                            switch(escenario) {
                                                case 'MISMA_EMPRESA_MISMO_TIPO':
                                                    mensaje = "Productos de la misma empresa y tipo - Solo se requiere descripción";
                                                    color = "#28a745";
                                                    break;
                                                case 'MISMA_EMPRESA_DIFERENTE_TIPO':
                                                    mensaje = "Productos de la misma empresa pero diferentes tipos - Se requiere definir tipo y tarifa";
                                                    color = "#ffc107";
                                                    break;
                                                case 'DIFERENTES_EMPRESAS':
                                                    mensaje = "Productos de diferentes empresas - Se requiere definir empresa arrendadora, tipo y tarifa";
                                                    color = "#dc3545";
                                                    break;
                                                default:
                                                    mensaje = "default";
                                                    color = "#dc3545";
                                            }
                                            
                                            return (
                                                <div className="mb-3 p-2" style={{ backgroundColor: color + "20", border: `1px solid ${color}`, borderRadius: "4px" }}>
                                                    <small style={{ color: color, fontWeight: "bold" }}>{mensaje}</small>
                                                </div>
                                            );
                                        })()}

                                        {/* DESCRIPCIÓN - Siempre visible */}
                                        <span className="p-float-label mt-2 mb-3">
                                            <InputText
                                                id="descripcionCombinada"
                                                value={productoCombinado.descripcionCombinada}
                                                onChange={(e) =>
                                                    setProductoCombinado({
                                                        ...productoCombinado,
                                                        descripcionCombinada: e.target.value.toUpperCase(),
                                                    })
                                                }
                                                className="p-inputtext-lg"
                                                placeholder="Ej: Producto 1 + Producto 2 + Producto 3"
                                                required
                                                maxLength={45}
                                            />
                                            <label htmlFor="descripcionCombinada">
                                                <i className="pi pi-file-edit mr-1"></i>Descripción Unión *
                                            </label>
                                        </span>

                                        {/* CAMPOS CONDICIONALES SEGÚN EL ESCENARIO */}
                                        {(() => {
                                            const escenario = determinarEscenarioCombinacion(productoCombinado.productos);

                                            if (escenario === 'DIFERENTES_EMPRESAS') {
                                                return (
                                                    <>
                                                        {/* EMPRESA ARRENDADORA */}
                                                        <span className="p-float-label mt-2 mb-3">
                                                            <Dropdown
                                                                id="empresaArrendadora"
                                                                value={productoCombinado.empresaArrendadora}
                                                                onChange={(e) =>
                                                                    setProductoCombinado({
                                                                        ...productoCombinado,
                                                                        empresaArrendadora: e.value,
                                                                    })
                                                                }
                                                                options={listaEmpresas}
                                                                optionLabel="nombre"
                                                                optionValue="nombre"
                                                                placeholder="Seleccione empresa arrendadora"
                                                                required
                                                            />
                                                            <label htmlFor="empresaArrendadora">
                                                                <i className="pi pi-building mr-1"></i>Empresa Arrendadora Responsable *
                                                            </label>
                                                        </span>
                                                    
                                                        {/* NUEVO TIPO DE PRODUCTO */}
                                                        <span className="p-float-label mt-2 mb-3">
                                                            <InputText
                                                                id="nuevoTipoProducto"
                                                                value={productoCombinado.nuevoTipoProducto}
                                                                onChange={(e) =>
                                                                    setProductoCombinado({
                                                                        ...productoCombinado,
                                                                        nuevoTipoProducto: e.target.value.toUpperCase(),
                                                                    })
                                                                }
                                                                placeholder="ingrese nombre del tipo de producto"
                                                                required
                                                            />
                                                            <label htmlFor="nuevoTipoProducto"><i className="pi pi-tag mr-1"></i> Nuevo Tipo *</label>
                                                        </span>
                                                    
                                                        {/* TARIFA */}
                                                        <span className="p-float-label mt-2 mb-3">
                                                            <InputNumber
                                                            id="tarifa"
                                                            value={productoCombinado.tarifa}
                                                            onValueChange={(e) => setProductoCombinado({...productoCombinado, tarifa: e.value})} // Handle value change
                                                            mode="decimal" // Handle decimal numbers
                                                            minFractionDigits={0} // Set minimum number of decimal digits
                                                            maxFractionDigits={2} // Set maximum number of decimal digits
                                                            placeholder="Ingrese la tarifa en UF"
                                                            className="p-inputtext-lg"
                                                            locale="es-ES" // Set locale to use comma for decimal
                                                            inputMode="decimal" // HTML5 input mode for numeric decima
                                                            min={0}
                                                            max={1000}
                                                            />
                
                                                            <label htmlFor="tarifa">
                                                                <i className="pi pi-dollar mr-1"></i>Nueva Tarifa (UF) *
                                                            </label>
                                                        </span>
                                                    </>
                                                );
                                            } else if (escenario === 'MISMA_EMPRESA_DIFERENTE_TIPO') {
                                                return (
                                                    <>
                                                        {/* NUEVO TIPO DE PRODUCTO */}
                                                        <span className="p-float-label mt-2 mb-3">
                                                            <InputText
                                                                id="nuevoTipoProducto"
                                                                value={productoCombinado.nuevoTipoProducto}
                                                                onChange={(e) =>
                                                                    setProductoCombinado({
                                                                        ...productoCombinado,
                                                                        nuevoTipoProducto: e.target.value.toUpperCase(),
                                                                    })
                                                                }
                                                                placeholder="ingrese nombre del tipo de producto"
                                                                required
                                                            />
                                                            <label htmlFor="nuevoTipoProducto"><i className="pi pi-tag mr-1"></i> Nuevo Tipo *</label>
                                                        </span>
                                                    
                                                        {/* TARIFA */}
                                                        <span className="p-float-label mt-2 mb-3">
                                                            <InputNumber
                                                            id="tarifa"
                                                            value={productoCombinado.tarifa}
                                                            onValueChange={(e) => setProductoCombinado({...productoCombinado, tarifa: e.value})} // Handle value change
                                                            mode="decimal" // Handle decimal numbers
                                                            minFractionDigits={0} // Set minimum number of decimal digits
                                                            maxFractionDigits={2} // Set maximum number of decimal digits
                                                            placeholder="Ingrese la tarifa en UF"
                                                            className="p-inputtext-lg"
                                                            locale="es-ES" // Set locale to use comma for decimal
                                                            inputMode="decimal" // HTML5 input mode for numeric decima
                                                            min={0}
                                                            max={1000}
                                                            />
                                                            <label htmlFor="tarifa">
                                                                <i className="pi pi-dollar mr-1"></i>Nueva Tarifa (UF) *
                                                            </label>
                                                        </span>
                                                    </>
                                                );
                                            }
                                            // Para MISMA_EMPRESA_MISMO_TIPO no se muestran campos adicionales
                                            return null;
                                        })()}

                                        {/* Resumen de productos */}
                                        <div className="mt-3">
                                            <h6 className="mb-2">
                                                <i className="pi pi-info-circle mr-2"></i>
                                                Resumen
                                            </h6>
                                            <div className="text-md text-600">
                                                <strong>Empresas involucradas:</strong> {[...new Set(productoCombinado.productos.map(p => p.nombreEmpresa))].join(', ')}<br/>
                                                <strong>Tipos de producto:</strong> {[...new Set(productoCombinado.productos.map(p => p.tipoProducto))].join(', ')}<br/>
                                                <strong>Productos a unir:</strong> {productoCombinado.productos.length}<br/>
                                                <strong>Metraje total calculado:</strong> {productoCombinado.productos.reduce((total, p) => total + parseFloat(p.metraje || 0), 0)} m²<br/>
                                                <strong>Remarcadores estimados:</strong> {productoCombinado.productos.length * 2}<br/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
            </Dialog>
        </>
    );
};
export default FormCrearComboProductos;